import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class BodyText {
    constructor(container) {
        this.container = container;
        this.content = this.container.querySelector('.body-text__content');

        this.init();
    }

    init = () => {
        if (!this.content) return;

        this.splitLines = new SplitText(this.content, { type: 'lines', linesClass: 'lineParent' });
        this.split = new SplitText(this.content.querySelectorAll('.lineParent'), { type: 'lines' });

        gsap.fromTo(
            this.split.lines,
            { yPercent: 100 },
            {
                yPercent: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: { each: 0.1, from: 'start' },
                scrollTrigger: {
                    trigger: this.content,
                    start: 'top 85%',
                },
                onComplete: () => {
                    this.split.revert();
                    this.splitLines.revert();
                },
            }
        );
    };
}
